import { render, staticRenderFns } from "./CreatePremadePlan.vue?vue&type=template&id=cfdb1440"
import script from "./CreatePremadePlan.vue?vue&type=script&lang=ts"
export * from "./CreatePremadePlan.vue?vue&type=script&lang=ts"
import style0 from "./CreatePremadePlan.vue?vue&type=style&index=0&id=cfdb1440&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports